import ajax from "plugins/AjaxService"
import { OsConfig } from "types/User"



/**
 * Restituisce i dati del OS 
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-63135
 */
function getOSConfig(): Promise<{ data: OsConfig }> {
	return ajax.get("os_config", null, { noAuth: true, noDialogError: true })
}


/**
 * Returns the data of CURRENT-USER
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-28675
 */
function getCurrent() {
	return ajax.get("user")
}

/**
 * Start the session with a user via email and password (and opt-code)
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-28695
 */
function login(email: string, password: string, otpCode: string) {
	if (otpCode == "") otpCode = undefined
	return ajax.post(
		"users/sign_in",
		{ api_user: { email, password, otpAttempt: otpCode } },
		{ isLogin: true }
	)
}

/**
 * Logs out the CURRENT-USER
 * https://airilabs.myjetbrains.com/youtrack/articles/ZOS-A-205/sign_out
 */
function logout() {
	return ajax.delete("users/sign_out")
}

const authApi = {
	getOSConfig,
	getCurrent,
	login,
	logout,
}

export default authApi


